import { booleanFlag, companyRolloutFlag, type FlagValues } from '@hello-aria/flags'

/**
 * Every makalu flag. Vercel Flags serves the values, per Vercel project and
 * environment. Each default is the production value of the env var the flag
 * replaced, so a project without its flags configured behaves like production.
 * A new flag defaults to `false`. These values reach the browser. A flag
 * whose value must stay on the server goes in `serverFeatureFlagModels.ts`.
 */
export const featureFlagDefinitions = {
    csvImportsRollout: companyRolloutFlag({
        key: 'csv-imports',
        description: 'The companies that see the CSV imports entry in the sidebar.',
        defaultValue: {
            include: [
                '659591e6d56c6fac8a44cd65',
                '68230eeb22dbb77dc9c9f696',
                '689df0f8e40b2671bf4dea8a',
                '691af41ea0a7cb7d88945bc4'
            ],
            exclude: []
        }
    }),
    hasProofs: booleanFlag({
        key: 'proofs',
        description: 'Shows the proofs of invoices, receivables and credit memos instead of their attachments.',
        defaultValue: false
    }),
    hasRepayments: booleanFlag({
        key: 'repayments',
        description: 'Shows the repayments entry in the sidebar of the Pages Router layout.',
        defaultValue: true
    }),
    hasRequirementsPortalLink: booleanFlag({
        key: 'requirements-portal-link',
        description: 'Lets a supplier mint a requirements portal link for its debtor.',
        defaultValue: true
    }),
    hasSDDRepayments: booleanFlag({
        key: 'sdd-repayments',
        description: 'Shows the SEPA direct debit repayments.',
        defaultValue: true
    }),
    hasUserLimits: booleanFlag({
        key: 'beneficiary-limits',
        description: 'Shows the user limits, for a company whose config enables them.',
        defaultValue: true
    })
}

export type FeatureFlags = FlagValues<typeof featureFlagDefinitions>
